export const GLOBAL_EVENT_ROLES = ['المشرف العام', 'نائب المشرف العام'];

export const EVENT_STAFF_ROLES = ['مسؤول قسم الفعاليات', 'مشرف الفعاليات'];

export const EVENT_CREATOR_ROLES = [...GLOBAL_EVENT_ROLES, ...EVENT_STAFF_ROLES];

export const EVENT_CONFIGURATION_ROLES = [...GLOBAL_EVENT_ROLES, 'مسؤول قسم الفعاليات'];

export const canManageAllEvents = (role) => GLOBAL_EVENT_ROLES.includes(role);

export const canCreateEvents = (role) => EVENT_CREATOR_ROLES.includes(role);

export const canConfigureEvents = (role) => EVENT_CONFIGURATION_ROLES.includes(role);

export const canViewUpcomingEvents = (role) => EVENT_CREATOR_ROLES.includes(role);

export const canEditEvent = (event, role, userId) =>
  canConfigureEvents(role) || Boolean(userId && event?.createdBy === userId);

export const getEventRules = (post) => {
  const rules = post?.eventRules || post?.officialRules || post?.rules;
  return Array.isArray(rules) ? rules.filter(Boolean) : [];
};

export const hasEventPrizes = (post) =>
  Boolean(post?.allWinners) || (Array.isArray(post?.prizes) && post.prizes.length > 0);

export const isPublishedEventPost = (post) =>
  post?.event === true && (getEventRules(post).length > 0 || hasEventPrizes(post));

export const canViewEventPost = (post, role, userId) =>
  post?.event !== true || isPublishedEventPost(post) || canConfigureEvents(role) || post?.createdBy === userId;
